import { render } from "./AdminNamespace.vue?vue&type=template&id=4cd0bce9&lang=pug"
import script from "./AdminNamespace.vue?vue&type=script&lang=js"
export * from "./AdminNamespace.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__